import * as React from 'react';
import { FormEvent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push, replace } from 'redux-router';
import { fetchUserInfoDeferred, productInfoDeferred } from '../actions/Actions';
import * as CustomTypes from '../CustomTypes';
import { IQuery, IState, Push, Replace } from '../CustomTypes';
import { createB64data } from '../fastflowUtils';
import LegalAge from '../gdpr/LegalAge';
import { svgAddress } from '../icons';
import {
  Address,
  Button,
  MobileNumber
} from '../input-components/InputComponents';
import {
  validateCity,
  validatePhoneNumber,
  validateZipCode
} from '../validators';
import './AddressPage.scss';
import { sccPulseTrackPageView } from '../PulseUtils';

export interface IStateProps {
  productInfo: CustomTypes.IProductInfo;
  userInfo: CustomTypes.IUserInfo;
  address: CustomTypes.IAddress;
  referer: CustomTypes.IReferer;
  paymentMethodId: string;
  purchasedSubscriptionId: string;
  pathname: string;
  query: IQuery;
}

export interface IDispatchProps {
  push: Push;
  replace: Replace;
}

export interface IProps extends IStateProps, IDispatchProps {}

export class AddressPage extends React.Component<
  IProps,
  { formSubmitted: boolean }
> {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      formSubmitted: false
    };
  }

  public componentDidMount() {
    const eventName = 'Delivery adress';
    productInfoDeferred.promise.then(product => {
      fetchUserInfoDeferred.promise
        .then(user => {
          sccPulseTrackPageView(product, user, eventName);
        })
        .catch(() => {
          sccPulseTrackPageView(product, this.props.userInfo, eventName);
        });
    });
  }

  public render() {
    const { paymentMethodId } = this.props;
    return (
      <div className="addressPage container">
        <h1>{svgAddress()}</h1>
        <h1>Gi oss din leveringsadresse</h1>
        <form className="row mask" onSubmit={this.onSubmit}>
          <div className="col-xs-12 mobileNumber">
            <MobileNumber
              initialFocus={true}
              validationErrorMessage={
                'Vennligst oppgi et gyldig norsk mobilnummer'
              }
            />
          </div>
          <Address
            formSubmitted={this.state.formSubmitted}
            validZipCodes={this.props.productInfo.validZipCodes}
          />
          <div className="col-xs-12">
            <Button type="submit" disabled={!this.isFormValid()}>
              {(paymentMethodId && 'Fullfør kjøp') || 'Til betaling'}
            </Button>
          </div>
        </form>
        <LegalAge />
      </div>
    );
  }

  private onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    this.setState({ formSubmitted: true });
    const { phoneNumber, spidId, sig, email } = this.props.userInfo;

    const formValid = this.isFormValid();
    if (formValid) {
      const { productId } = this.props.productInfo;
      const { paymentMethodId, purchasedSubscriptionId } = this.props;
      const b64data = createB64data(
        this.props.address,
        this.props.referer,
        phoneNumber,
        false,
        email
      );
      let rctParam = '';
      if (this.props.query.__rct) {
        rctParam += `&__rct=${this.props.query.__rct}`;
      }
      if (paymentMethodId && purchasedSubscriptionId) {
        const params = `paymentMethodId=${paymentMethodId}&purchasedSubscriptionId=${purchasedSubscriptionId}&b64data=${encodeURIComponent(
          b64data
        )}${rctParam}`;
        this.props.push(`/products/${productId}/placeorder?${params}`);
      } else {
        this.props.push(
          `/products/${productId}/selectpaymentmethod?spidId=${spidId}&sig=${sig}&b64data=${encodeURIComponent(
            b64data
          )}${rctParam}`
        );
      }
    }
  }

  private isFormValid() {
    const { phoneNumber } = this.props.userInfo;
    const { zipCode, city } = this.props.address;
    if (phoneNumber && !validatePhoneNumber(phoneNumber)) {
      return false;
    }
    return (
      validateZipCode(zipCode, this.props.productInfo.validZipCodes) &&
      validateCity(city)
    );
  }
}

export default connect<IStateProps, IDispatchProps, {}>(
  (state: IState) =>
    ({
      address: state.address,
      pathname: state.router.location.pathname,
      paymentMethodId: state.router.location.query.paymentMethodId,
      productInfo: state.productInfo,
      purchasedSubscriptionId:
        state.router.location.query.purchasedSubscriptionId,
      query: state.router.location.query,
      referer: state.referer,
      userInfo: state.userInfo
    } as IStateProps),
  dispatch =>
    bindActionCreators(
      {
        push,
        replace
      },
      dispatch
    ) as IDispatchProps
)(AddressPage);



// WEBPACK FOOTER //
// ./src/page-components/AddressPage.tsx